// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"461525f8","88":"9a3bf528","486":"898e7d60","707":"ddef869c"}[chunkId] + ".chunk.css";
};